export default __webpack_public_path__ + "static/media/google.1cd7680a.svg";